import { isNotEmptyObject } from "@/utils";

export const getCameraDevices = (state: DevicesStore) =>
  Object.values(state.devices).filter(
    (device): device is StoreCameraDevice => device.role === "camera" && device.deviceType !== "viewer"
  );

export const getInactiveCameraDevices = (state: DevicesStore) =>
  Object.values(state.devices).filter(
    (device): device is StoreCameraDevice => device.role === "camera" && device.deviceType === "viewer"
  );

export const getViewerDevices = (state: DevicesStore) =>
  Object.values(state.devices).filter(
    (device): device is StoreViewerDevice => device.role === "viewer" || device.deviceType === "viewer"
  );

export const getCameraStationsWithoutDevice = (state: DevicesStore) => Object.values(state.cameraStationsWithoutDevice);

export const getCameraStationWithoutDeviceByObjectId = (objectId?: string) => (state: DevicesStore) =>
  objectId ? state.cameraStationsWithoutDevice[objectId] : undefined;

export const getCameraStationCount = (state: DevicesStore) =>
  Object.values(state.devices).filter((device) => device.role === "camera").length;

export const hasPairedDevices = (state: DevicesStore) => isNotEmptyObject(state.devices);

export const getDeviceByObjectId = (objectId?: string) => (state: DevicesStore) =>
  Object.values(state.devices).find((d) => d.objectId === objectId);

const selectors = {
  getCameraDevices,
  getInactiveCameraDevices,
  getViewerDevices,
  getCameraStationsWithoutDevice,
  getCameraStationWithoutDeviceByObjectId,
  getCameraStationCount,
  hasPairedDevices,
  getDeviceByObjectId
};

export default selectors;
